<template lang="pug">
  li.v-tab(
    :class="{ 'v-tab--active': active }"
    @click="$emit('click')")
    slot
</template>

<script>
export default {
  name: 'VTab',

  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
